/**
 * Directives
 * @module directives
 */
define(function (require, exports) {
    'use strict';

    // @ngInject
    exports.metOnlyNumber = function () {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    return;
                }

                ngModelCtrl.$parsers.push(function (val) {
                    if (!val) return '';

                    var clean = val.replace(/\D+/g, '');
                    if (val !== clean) {
                        ngModelCtrl.$setViewValue(clean);
                        ngModelCtrl.$render();
                    }
                    return clean;
                });
            }
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/onlyNumberInputDirective.js